import { Groq } from 'groq-sdk';

// Initialize the Groq client with the API key and allow browser usage
// Note: This is not recommended for production apps as it exposes your API key
const groq = new Groq({
  apiKey: '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',
  dangerouslyAllowBrowser: true // Enable browser usage (not secure for production)
});

/**
 * Generate motivational content using the Groq API
 * @param {string} prompt - User's prompt for motivation
 * @returns {Promise<string>} - The generated motivational text
 */
export const generateMotivation = async (prompt) => {
  try {
    // Create a system message to guide the AI's response style
    const systemMessage = {
      role: "system",
      content: `You are a blunt, no-BS motivational coach. Your responses MUST be:
      1. Extremely short and direct - use 1-2 short paragraphs max
      2. Borderline rude when the user needs a reality check
      3. Zero fluff or coddling - cut straight to what they need to hear
      4. Focused on immediate action, not feelings
      5. Willing to call out excuses and weak mindsets

      Use short sentences. Be abrupt. If they're making excuses, call them out harshly.
      Don't soften your message. Be the drill sergeant they need, not the friend they want.`
    };

    // Create a user message with the prompt
    const userMessage = {
      role: "user",
      content: prompt || "I need motivation to get started on my goals."
    };

    // Make the API call
    const response = await groq.chat.completions.create({
      messages: [systemMessage, userMessage],
      model: "llama-3.3-70b-versatile",
      temperature: 0.9, // Higher temperature for more unpredictable, direct responses
      max_tokens: 300, // Reduced token count to keep responses shorter
      top_p: 1,
      stream: false,
      stop: null
    });

    // Return the generated content
    return response.choices[0]?.message?.content || "Failed to generate motivation. Please try again.";
  } catch (error) {
    console.error("Error generating motivation:", error);
    return "An error occurred while generating motivation. Please try again later.";
  }
};
